import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import WP_App_Routes from "./Routes";

const PrivateRoute = () => {
  const idToken = useSelector(state => state.Auth.idToken);
  const isUserBlocked = useSelector(state => state.userInfo?.data?.isBlocked);

  if (isUserBlocked) {
    return <Navigate to={WP_App_Routes.blockedUser} />;
  }
  return idToken ? <Outlet /> : <Navigate to='/' />;
};
export default PrivateRoute;
